import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailName'
  })
export class EmailNamePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {return value;}

    const [localPart] = value.split('@');
    const [firstName, lastName] = localPart.split('.');

    if (firstName && lastName) {
      return `${this.capitalize(firstName)} ${this.capitalize(lastName)} `;
    }

    return value;
  }

  private capitalize(word: string): string {
    if (!word) {return word;}
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }
}
